import styled from "styled-components";

const MessagesStyle = styled.div`
  .message-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .message-title {
    font-size: 20px;
    font-weight: 500;
    color: #1f243b;
    margin: 0;
  }

  .send-message-button {
    height: 40px;
    padding: 0 20px;
    border-radius: 8px;
    border: none;
    background-color: #c2fae5;
    color: #1f243b;
    font-size: 14px;
    cursor: pointer;
  }

  .send-message-button:hover {
    background-color: #a9f2d8;
  }

  .message-tabs {
    margin-top: 20px;
  }

  .message-tabs .ant-tabs-nav {
    margin-bottom: 16px;
  }

  .message-tabs .ant-tabs-tab {
    font-size: 15px;
    color: #636980;
  }

  .message-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #1f243b !important;
    font-weight: 500;
  }

  .message-tabs .ant-tabs-ink-bar {
    background: #1f243b;
  }

  .message-search {
    max-width: 280px;
    margin-bottom: 16px;
    border-radius: 24px;
  }

  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    border: 1px solid #00000024;
    border-radius: 8px;
  }

  .ant-table-cell {
    padding: 20px;
    color: #636980;
    font-family: "DM Sans", sans-serif;
  }

  .ant-table-thead {
    font-family: "DM Sans", sans-serif;
    font-weight: 500;
    color: #1f243b;
    white-space: nowrap;
  }

  .ant-table-thead > tr > th::before {
    display: none !important;
  }

  .non-white {
    background: #f9f9f9;
  }

  .ant-table-cell-row-hover {
    background: transparent !important;
  }

  .message-sender-name {
    color: #1f243b;
    font-weight: 500;
  }

  .message-empty-hint {
    color: #636980;
    font-size: 14px;
  }

  /* Date and paperclip stay on one line. */
  .message-date-cell {
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
  }

  .message-attachment-flag {
    margin-left: 8px;
    flex-shrink: 0;
  }

  .table_action_icons {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
    opacity: 0;
    transition: opacity 0.15s ease;
  }

  .ant-table-tbody > tr:hover .table_action_icons {
    opacity: 1;
  }

  .replyIcon,
  .forwardIcon {
    display: inline-flex;
    width: 20px;
    height: 20px;
    cursor: pointer;
    color: #2bb791;
  }

  .deleteIcon {
    display: inline-flex;
    width: 20px;
    height: 20px;
    cursor: pointer;
    color: #ff6b45;
  }
`;

// Modal content is portaled to document.body (a JSX sibling, not a
// descendant of MessagesStyle), so styles scoped there never reach it -
// same fix Courses/index.js's DeleteModalContent uses.
export const DeleteModalContent = styled.div`
  .delete-modal-title {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #1f243b;
    text-align: left;
  }

  .delete-modal-body {
    margin: 20px 0 28px;
    font-size: 16px;
    color: #1f243b;
    text-align: left;
  }

  .delete-modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
  }

  .delete-modal-cancel,
  .delete-modal-confirm {
    min-width: 130px;
    height: 40px;
    border-radius: 8px;
    font-size: 16px;
    cursor: pointer;
  }

  .delete-modal-cancel {
    background: #ffffff;
    border: 1px solid #1f243b;
    color: #1f243b;
  }

  .delete-modal-confirm {
    background: #c2fae5;
    border: none;
    color: #1f243b;
  }

  .delete-modal-confirm:hover,
  .delete-modal-cancel:hover {
    background: #a9f2d8 !important;
    color: #1f243b !important;
    border-color: #1f243b !important;
  }
`;

export default MessagesStyle;
